const ContentType = {
  jpg: 'image/jpeg',
  png: 'image/png',
};

export const getContentType = (ext: string) =>
  ContentType[ext as keyof typeof ContentType];
